export default __webpack_public_path__ + "static/media/shop.6b6eb2fe.svg";